import React, { ReactElement } from 'react';
import {
  Col,
  FormGroup,
  Heading,
  Label,
  Row,
  Textarea,
} from 'idsk-react-components';
import './vyhodnotenieFormSection.scss';
import { SafeParameterSetter } from '../../../types/SafeParameterSetter';
import VyhodnotenieSelectBox from '../../VyhodnotenieForm/component/VyhodnotenieSelectBox';
import { SearchPouzivatelList } from '../../SearchLdapData';

import SaveAdminPripomienka from '../../../model/pripomienka/SaveAdminPripomienka';

interface Props {
  pripomienka: SaveAdminPripomienka,
  onUpdateField: SafeParameterSetter<SaveAdminPripomienka>;
  getFieldErrorMessage: (fieldName: string) => string;
}

const VyhodnotenieFormSection = ({ onUpdateField, pripomienka, getFieldErrorMessage }: Props): ReactElement => (
  <section className="add-pripomienka-admin__vyhodnotenie-form-section">
    <Row>
      <Col>
        <Heading size="m">VYHODNOTENIE</Heading>
      </Col>
    </Row>
    <SearchPouzivatelList
      pouzivatel={pripomienka.priradeny}
      setPouzivatel={(data) => onUpdateField('priradeny', data)}
      label="Priradená"
    />
    <SearchPouzivatelList
      pouzivatel={pripomienka.vyhodnotil}
      setPouzivatel={(data) => onUpdateField('vyhodnotil', data)}
      label="Vyhodnotil používateľ"
    />
    <VyhodnotenieSelectBox updateField={onUpdateField} stavFromDetail={pripomienka.stavPripomienky} />
    <FormGroup error={!!getFieldErrorMessage('textVyhodnotenia')}>
      <Label htmlFor="textVyhodnotenia">Text vyhodnotenia</Label>
      <Textarea
        id="textVyhodnotenia"
        rows={7}
        maxLength={65000}
        name="textVyhodnotenia"
        error={getFieldErrorMessage('textVyhodnotenia')}
        onChange={({ target }) => onUpdateField('textVyhodnotenia', target.value)}
        defaultValue={pripomienka.textVyhodnotenia}
      />
    </FormGroup>
  </section>
);

export default VyhodnotenieFormSection;
